// extracted by mini-css-extract-plugin
export default {"mainLayout":"onboard_mainLayout__Lfl6E","MainBody":"onboard_MainBody__hg6T2"};